import { render, staticRenderFns } from "./AgoraView.vue?vue&type=template&id=0b3a11a6&"
import script from "./AgoraView.vue?vue&type=script&lang=js&"
export * from "./AgoraView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports